export const capitalizeFirstChar = (text: string = '') => {
  return text[0].toUpperCase() + text.slice(1);
};

export const containsOnlyWhiteSpaces = (text: string) => {
  return !/\S/.test(text);
};
